<script>
  export default {
    name: 'IconDeactivatedFilial',
  }
</script>

<template>
  <span class="icon-deactivated-filial">
    <font-awesome-icon icon="times" />
  </span>
</template>

<style scoped lang="less">
  .icon-deactivated-filial {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid;
    width: 18px;
    height: 18px;
    font-size: 11px;
  }
</style>
